import React, { useContext } from 'react';

// DEPENDENCIES
import { useParams } from 'react-router-dom';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// HELPERS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import SaveField from '../../../tools/SaveField';

// STYLES
import styles from './processedThroughFinance.module.scss';

// MAIN COMPONENT
const ProcessedThroughFinance = () => {
  const { recordID } = useParams();

  const { record: { process_through_finance } = {}, refetchRecord } = useContext(RecordContext) || {};

  return (
    <Form initialValues={{ process_through_finance }} className={styles.form}>
      <Form.Body>
        <SaveField endpoint={ENDPOINTS.amFinance.processThroughFinance(recordID)} onSuccess={() => refetchRecord()}>
          <Form.YesNo name="process_through_finance" label="Will this be processed through Finance?" numeric={false} />
        </SaveField>
      </Form.Body>
    </Form>
  );
};

// EXPORT
export default ProcessedThroughFinance;
